import React from "react";

/**
 * Small circular progress with percentage in the middle.
 * pct = 0..100+ (can be > 100). If null, shows dash.
 */
export default function ProgressRing({ pct, size = 40, stroke = 4, testId }) {
  const hasVal = pct !== null && pct !== undefined && !Number.isNaN(pct);
  const clamped = Math.max(0, Math.min(100, hasVal ? pct : 0));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const off = c - (clamped / 100) * c;

  const color = !hasVal ? "#DEDCD4" : pct >= 100 ? "#BE2E6C" : pct >= 80 ? "#8A5A00" : "#0E62C4";

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid={testId}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="#E5E4DE" strokeWidth={stroke} fill="none" />
        {hasVal && (
          <circle
            cx={size / 2} cy={size / 2} r={r} stroke={color} strokeWidth={stroke} fill="none"
            strokeDasharray={c} strokeDashoffset={off} strokeLinecap="round"
            style={{ transition: "stroke-dashoffset 0.4s ease" }}
          />
        )}
      </svg>
      <span
        className="absolute font-mono font-medium"
        style={{ color, fontSize: size <= 36 ? 9 : 10 }}
      >
        {hasVal ? `${Math.round(pct)}%` : "—"}
      </span>
    </div>
  );
}
